import { SVGPropsIcon } from 'src/types';

export const Gobelet = (props: SVGPropsIcon) => (
  <svg
    {...props}
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    onClick={props.onClick}>
    <g id="Vector">
      <path
        d="M20.1713 1.81375H3.65473C3.65473 1.81375 3.46103 16.7821 11.6924 17.182V17.1902C11.7671 17.1902 11.8403 17.1902 11.9134 17.1902C11.9866 17.1902 12.0605 17.1902 12.1353 17.1902V17.182C20.365 16.7821 20.1713 1.81375 20.1713 1.81375Z"
        fill="#FFD13D"
      />
      <path
        d="M20.1713 1.81375H15.7401C15.7217 3.64646 15.3567 14.6007 9.37593 16.6123C10.1039 16.9553 10.8903 17.1488 11.6908 17.182V17.1902C11.7655 17.1902 11.8387 17.1902 11.9118 17.1902C11.985 17.1902 12.0589 17.1902 12.1336 17.1902V17.182C20.365 16.7821 20.1713 1.81375 20.1713 1.81375Z"
        fill="#FCAF00"
      />
      <path
        d="M16.6942 14.059L16.3357 13.2297C16.4097 13.1959 23.7304 9.82063 23.0721 6.01423C22.9354 5.21865 22.6453 4.73719 22.2104 4.58302C21.1093 4.19224 19.1103 5.71001 18.4979 6.2731L17.9079 5.59707C18.1892 5.33902 20.7106 3.09079 22.499 3.72643C23.2602 3.99602 23.7456 4.71575 23.9458 5.85594C24.7166 10.359 17.0213 13.9098 16.6942 14.059Z"
        fill="#FCAF00"
      />
      <path
        d="M7.30382 14.059C6.97589 13.9098 -0.719353 10.359 0.0546721 5.85594C0.251594 4.71328 0.737068 3.99602 1.50145 3.72643C3.29063 3.09079 5.81123 5.33902 6.09255 5.59707L5.50339 6.2731C4.84511 5.67044 2.89437 4.19059 1.79 4.58302C1.35516 4.73801 1.06661 5.21948 0.929168 6.01423C0.2741 9.82063 7.59077 13.1959 7.66471 13.2297L7.30382 14.059Z"
        fill="#FFD13D"
      />
      <path
        d="M19.9704 1.89619H3.85567C3.61053 1.89619 3.37542 1.79631 3.20208 1.6185C3.02873 1.4407 2.93135 1.19955 2.93135 0.948097C2.93135 0.696646 3.02873 0.455494 3.20208 0.277691C3.37542 0.0998884 3.61053 0 3.85567 0H19.9704C20.2155 0 20.4506 0.0998884 20.624 0.277691C20.7973 0.455494 20.8947 0.696646 20.8947 0.948097C20.8947 1.19955 20.7973 1.4407 20.624 1.6185C20.4506 1.79631 20.2155 1.89619 19.9704 1.89619Z"
        fill="#FFD527"
      />
      <path
        d="M12.8972 16.5249C12.8972 16.5249 13.3835 22.6257 16.3349 23H11.9142V16.5694L12.8972 16.5249Z"
        fill="#FCAF00"
      />
      <path
        d="M12.8972 16.5249C12.8972 16.5249 13.3835 22.6257 16.3349 23H11.9142V16.5694L12.8972 16.5249Z"
        fill="#FFD13D"
      />
      <path
        d="M10.92 16.5249C10.92 16.5249 10.4377 22.6257 7.48226 23H11.903V16.5694L10.92 16.5249Z"
        fill="#FCAF00"
      />
      <path
        d="M6.46952 23C6.46952 22.5736 6.63465 22.1647 6.92858 21.8632C7.22251 21.5617 7.62117 21.3924 8.03686 21.3924H15.7731C16.1888 21.3924 16.5874 21.5617 16.8814 21.8632C17.1753 22.1647 17.3404 22.5736 17.3404 23H6.46952Z"
        fill="#FED03A"
      />
      <path
        d="M10.7672 21.8458C10.7672 22.0395 10.068 22.1962 9.20553 22.1962C8.34309 22.1962 7.64301 22.0395 7.64301 21.8458C7.64301 21.6521 8.34309 21.4962 9.20553 21.4962C10.068 21.4962 10.7672 21.6529 10.7672 21.8458Z"
        fill="#FEF68E"
      />
      <path
        d="M6.46952 7.54273C7.51403 7.54273 8.36077 6.4354 8.36077 5.06943C8.36077 3.70347 7.51403 2.59614 6.46952 2.59614C5.425 2.59614 4.57826 3.70347 4.57826 5.06943C4.57826 6.4354 5.425 7.54273 6.46952 7.54273Z"
        fill="#FEF68E"
      />
      <path
        d="M5.74934 1.11298C6.79519 1.11298 7.64301 0.900745 7.64301 0.638935C7.64301 0.377125 6.79519 0.164887 5.74934 0.164887C4.7035 0.164887 3.85567 0.377125 3.85567 0.638935C3.85567 0.900745 4.7035 1.11298 5.74934 1.11298Z"
        fill="#FEF68E"
      />
      <path
        d="M9.14284 1.11298C9.66576 1.11298 10.0897 0.900745 10.0897 0.638935C10.0897 0.377125 9.66576 0.164887 9.14284 0.164887C8.61992 0.164887 8.196 0.377125 8.196 0.638935C8.196 0.900745 8.61992 1.11298 9.14284 1.11298Z"
        fill="#FEF68E"
      />
      <path
        d="M11.9311 4.10814L12.7791 5.8716L14.6768 6.15439C14.6804 6.15499 14.6838 6.1566 14.6866 6.15903C14.6893 6.16147 14.6914 6.16464 14.6926 6.16821C14.6937 6.17177 14.6939 6.1756 14.6931 6.17926C14.6923 6.18293 14.6905 6.1863 14.688 6.18901L13.3184 7.55757L13.6399 9.49581C13.6404 9.49955 13.64 9.50336 13.6385 9.50685C13.6371 9.51033 13.6348 9.51334 13.6318 9.51556C13.6288 9.51777 13.6253 9.51909 13.6216 9.51939C13.6179 9.51969 13.6143 9.51895 13.611 9.51724L11.9134 8.60212L10.2167 9.51724C10.2134 9.51895 10.2097 9.51969 10.206 9.51939C10.2023 9.51909 10.1988 9.51777 10.1958 9.51556C10.1929 9.51334 10.1905 9.51033 10.1891 9.50685C10.1877 9.50336 10.1872 9.49955 10.1877 9.49581L10.5092 7.55757L9.13882 6.18489C9.13628 6.18218 9.13451 6.17881 9.1337 6.17514C9.1329 6.17148 9.13308 6.16765 9.13424 6.16409C9.1354 6.16052 9.13749 6.15735 9.14028 6.15491C9.14307 6.15247 9.14645 6.15087 9.15007 6.15026L11.047 5.86748L11.8949 4.10814C11.8966 4.10466 11.8991 4.10172 11.9023 4.09966C11.9055 4.09761 11.9092 4.09652 11.913 4.09652C11.9168 4.09652 11.9205 4.09761 11.9237 4.09966C11.9269 4.10172 11.9295 4.10466 11.9311 4.10814Z"
        fill="#E9A600"
      />
    </g>
  </svg>
);
